import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { EcgItem } from '../types/ecg.type';

export const loaded = action(
  '[EcgList] loaded',
  props<{ ecgItems: EcgItem[] } & SkipHistory>(),
);

export const reset = action('[EcgList] reset', props<SkipHistory>());

export const done = action('[EcgList] done', props<SkipHistory>());

export const incrementIndex = action(
  '[EcgList] incrementIndex',
  props<SkipHistory>(),
);
